"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../svg/Icon");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var smallScreen = 1024;
var Toast = exports.default = /*#__PURE__*/function (_React$Component) {
  _inherits(Toast, _React$Component);
  var _super = _createSuper(Toast);
  function Toast(props) {
    var _this;
    _classCallCheck(this, Toast);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "selfDelete", function () {
      var _this$state = _this.state,
        autoDelete = _this$state.autoDelete,
        autoDeleteTime = _this$state.autoDeleteTime,
        toastList = _this$state.toastList;
      var selfDeleteIntervalClock = autoDeleteTime ? autoDeleteTime + 5000 : 10000;
      var interval = setInterval(function () {
        var time = Date.now();
        if (autoDelete && toastList.length) {
          var first = _toConsumableArray(toastList);
          var extendedTime = first[0]['time'] + autoDeleteTime;
          if (time > extendedTime) {
            _this.deleteToast(first[0]['id']);
          }
        }
      }, 500);
      setTimeout(function () {
        clearInterval(interval);
      }, selfDeleteIntervalClock);
    });
    _defineProperty(_assertThisInitialized(_this), "deleteToast", function (id) {
      var toastList = _this.state.toastList;
      if (toastList.length) {
        var _document$getElementB;
        var toastDivId = (_document$getElementB = document.getElementById(id)) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.classList;
        toastDivId === null || toastDivId === void 0 ? void 0 : toastDivId.add('tl-toast-animation-off');
        setTimeout(function () {
          toastDivId === null || toastDivId === void 0 ? void 0 : toastDivId.remove('tl-toast-animation-off');
          var listItemIndex = toastList.findIndex(function (e) {
            return e['id'] === id;
          });
          toastList.splice(listItemIndex, 1);
          _this.setState({
            toastList: toastList
          });
          if (_this.props.closeToast) {
            _this.props.closeToast(id);
          }
        }, 600);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "getToastType", function (type) {
      var toastClassName = 'tl-toast-generic';
      var toastIconName = 'icon-system-info-small';
      if (type === 'generic') {
        toastClassName = 'tl-toast-generic';
        toastIconName = 'icon-system-info-small';
      } else if (type === 'success') {
        toastClassName = 'tl-toast-success';
        toastIconName = 'icon-system-tick-copy';
      } else if (type === 'warning') {
        toastClassName = 'tl-toast-warning';
        toastIconName = 'icon-system-alert-small';
      }
      toastClassName += ' ' + _this.state.smallDeviceClass;
      return {
        toastClassName: toastClassName,
        toastIconName: toastIconName
      };
    });
    _defineProperty(_assertThisInitialized(_this), "getToastClass", function (type) {
      var toastClassName = '';
      if (type === 'generic') {
        toastClassName = 'tl-generic';
      } else if (type === 'success') {
        toastClassName = 'tl-success';
      } else if (type === 'warning') {
        toastClassName = 'tl-warning';
      }
      return toastClassName;
    });
    _defineProperty(_assertThisInitialized(_this), "getToastMessageClass", function (message) {
      return message.length > 42 ? 'tl-toast-long-message' : '';
    });
    _defineProperty(_assertThisInitialized(_this), "getToastMessage", function (message) {
      //Increased from 80 to 110
      var msgLengthValue = 110;
      if (_this.state.smallDeviceClass) {
        //increased the message in small device in same ratio
        msgLengthValue = 82;
      }
      var messageHeight = message.length > msgLengthValue ? message.substring(0, msgLengthValue) + '...' : message;
      return messageHeight;
    });
    _defineProperty(_assertThisInitialized(_this), "getToastDivClass", function (toast) {
      var className = '';
      var longMessage = toast.description.length > 42 ? true : false;
      var actionButton = toast.actionButton ? true : false;
      if (longMessage && actionButton) {
        className = 'tl-toast-multi-line-button';
      } else if (actionButton) {
        className = 'tl-toast-action-button';
      }
      return className;
    });
    _this.state = {
      toastList: [],
      autoDelete: false,
      autoDeleteTime: 0,
      position: '',
      smallDeviceClass: ''
    };
    _this.updateDimensions = _this.updateDimensions.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(Toast, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateDimensions();
      window.addEventListener('resize', this.updateDimensions);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateDimensions);
    }
  }, {
    key: "updateDimensions",
    value: function updateDimensions() {
      var modalClass = '';
      var windowInnerWidth = window.innerWidth;
      if (windowInnerWidth < smallScreen) {
        modalClass = 'mobile-device';
      }
      this.setState({
        smallDeviceClass: modalClass
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$state2 = this.state,
        toastList = _this$state2.toastList,
        position = _this$state2.position;
      if (toastList.length) {
        this.selfDelete();
      }
      var toastContainerClass = "tl-toast-container tl-toast-" + position + ' ' + this.state.smallDeviceClass;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: toastContainerClass
      }, toastList.map(function (toast, i) {
        return /*#__PURE__*/_react.default.createElement("div", {
          key: i,
          className: "tl-toast tl-toast-animation ".concat(_this2.getToastDivClass(toast), " ").concat(position, " ").concat(_this2.getToastType(toast.type).toastClassName),
          role: toast.type === 'warning' ? "alert" : 'status',
          "aria-live": toast.type === 'warning' ? "assertive" : 'polite',
          "aria-atomic": "true",
          id: toast.id
        }, /*#__PURE__*/_react.default.createElement("div", {
          "aria-label": "Close",
          className: "tl-toast-cross-button ".concat(toast.closeIcon === false ? "tl-toast-hide" : 'tl-toast-show'),
          onClick: function onClick() {
            return _this2.deleteToast(toast.id);
          }
        }, /*#__PURE__*/_react.default.createElement(_Icon.SvgIcon, {
          className: "tl-toast-cross-icon ui-modal-cross-button",
          name: "icon-system-close"
        })), /*#__PURE__*/_react.default.createElement("div", {
          className: "tl-toast-image ".concat(toast.toastIcon === false ? "tl-toast-hide" : 'tl-toast-show')
        }, /*#__PURE__*/_react.default.createElement(_Icon.SvgIcon, {
          className: "tl-toast-left-icon ".concat(_this2.getToastClass(toast.type)),
          name: _this2.getToastType(toast.type).toastIconName
        })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", {
          className: "tl-toast-message ".concat(_this2.getToastMessageClass(toast.description))
        }, _this2.getToastMessage(toast.description)), /*#__PURE__*/_react.default.createElement("p", {
          className: "tl-toast-button ".concat(toast.toastIcon === false ? 'tl-toast-with-no-icon' : 'tl-toast-with-icon', " ").concat(toast.actionButton ? "tl-toast-show" : 'tl-toast-hide')
        }, toast.actionButton)));
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.toastList !== prevState.toastList) {
        return {
          toastList: nextProps.toastList,
          autoDelete: nextProps.autoDelete,
          autoDeleteTime: nextProps.autoDeleteTime,
          position: nextProps.position
        };
      } else return null;
    }
  }]);
  return Toast;
}(_react.default.Component);